// extracted by mini-css-extract-plugin
export var component = "Menu-module--component--dKhSa";
export var list = "Menu-module--list--Dqx2S";